module.exports = __webpack_public_path__ + "static/media/Photo33.4184a659.jpg";